import { useNavigation } from '@/context/NavigationContext'
import Dashboard from '@/features/dashboard/Dashboard'
import HabitTracker from '@/features/habit/HabitTracker'
import WeeklyPlanner from '@/features/weekly/WeeklyPlanner'
import TasksPlanner from '@/features/tasks/TasksPlanner'
import FinanceTracker from '@/features/finance/FinanceTracker'
import Settings from '@/features/settings/Settings'

export default function PageContent() {
  const { currentPage } = useNavigation()

  switch (currentPage) {
    case '/':
      return <Dashboard />
    case '/habit':
      return <HabitTracker />
    case '/weekly':
      return <WeeklyPlanner />
    case '/tasks':
      return <TasksPlanner />
    case '/finance':
      return <FinanceTracker />
    case '/settings':
      return <Settings />
    default:
      return <Dashboard />
  }
}
